export class PeriodoFormacao {
    constructor({
      id = null,
      dataInicio = null,
      dataFim = null,
      perfis = Array(),
    }) {
      this.id = id;
      this.dataInicio = this.convertToDateTime(dataInicio);
      this.dataFim = this.convertToDateTime(dataFim); 
      this.perfis = perfis;
    }
  
    convertToDateTime(dateString) {
      if (!dateString) return null;
  
      const [day, month, year] = dateString.split('/');
      return new Date(`${year}-${month}-${day}`);
    }
  
    static Build() {
      return new PeriodoFormacao({
        id: null,
        dataInicio: null,
        dataFim: null,
        perfis: Array(),
      });
    }
  
    format() {
      this.perfis = this.perfis.map((p) => p.id);
      return this;
    }
  }
  